import { Component, OnInit } from '@angular/core';
import {
  DynamicDialogRef,
  DynamicDialogConfig,
  DialogService,
} from 'primeng/dynamicdialog';
import { Tenant } from 'src/app/core/models/tenant';
import { TenantService } from 'src/app/core/services/tenant.service';
import { AppToastService } from 'src/app/shared/services/app-toast.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-tenant-modal',
  templateUrl: './tenant-modal.component.html',
  standalone: false,
  providers: [DialogService],
})
export class TenantModalComponent implements OnInit {
  tenantId: string;
  model: any = { primaryColor: '#000000' };
  active: boolean = true;
  /** Spinner do botão Save durante o submit — separado do skeleton. */
  submitting = false;
  /** Skeleton do modal enquanto o get de abertura (modo edição) não termina. */
  initialLoading = false;

  // Variável para armazenar o arquivo selecionado
  selectedFile: File | null = null;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private tenantService: TenantService,
    private readonly toastService: AppToastService,
  ) {}

  ngOnInit(): void {
    if (this.config.data && this.config.data.tenantId) {
      this.tenantId = this.config.data.tenantId;
      this.initialLoading = true;
      this.getTenant();
    }
  }

  getTenant() {
    this.tenantService
      .getTenant(this.tenantId)
      .pipe(finalize(() => (this.initialLoading = false)))
      .subscribe({
      next: (data: Tenant) => {
        this.model = data;
        this.active = data.active;
      },
      error: () => {},
    });
  }

  onFileSelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
    }
  }

  newOrSaveRecord() {
    this.submitting = true;

    this.model.active = this.active;

    const formData = new FormData();
    Object.keys(this.model).forEach((key) => {
      if (this.model[key] !== null && this.model[key] !== undefined) {
        formData.append(key, this.model[key]);
      }
    });
    if (this.selectedFile) {
      formData.append('file', this.selectedFile);
    }

    const request$ = this.model.id
      ? this.tenantService.updateTenant(this.model.id, formData)
      : this.tenantService.addTenant(formData);

    request$.pipe(finalize(() => (this.submitting = false))).subscribe({
      next: () => {
        this.toastService.success(
          this.model.id ? 'Tenant Updated' : 'Tenant Created',
          this.model.id
            ? 'The tenant was updated successfully.'
            : 'The tenant was created successfully.',
        );
        this.ref.close('success');
      },
      error: () => {},
    });
  }
}
